import React, { Component } from 'react'
import { connect } from 'react-redux'
import { listAssetEvents } from '../redux/actionCreators/assetEvents'

class AssetEvents extends Component {
  componentDidMount() {
    if (this.props.canMakeResourceRequest) this.props.listAssetEvents()
  }
  
  componentDidUpdate() {
    if (this.props.canMakeResourceRequest && !this.props.resourceLoaded) this.props.listAssetEvents()
  }
  
  render() {
    if (!this.props.resourceLoaded) return (
      <div>Loading</div>
    )
    
    return (
      <div className="table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th>Timestamp</th>
              <th>DevEUI</th>
              <th>Raw Distance</th>
              <th>Smoothed Distance</th>
              <th>Fill Level</th>
              <th>Temperature</th>
              <th>Battery Level</th>
              <th>Spreading Factor</th>
              <th>Errors</th>
            </tr>
          </thead>
          <tbody>
            {this.props.events.map((eventObj, index) => {
              let date = new Date(0)
              date.setUTCMilliseconds(parseInt(eventObj.timestamp.N))
              return (
                <tr key={eventObj.timestamp.N}>
                  <td>{date.toLocaleString()}</td>
                  <td>{eventObj.sensor_dev_eui.S}</td>
                  <td>{(eventObj.sensor_entity_update.M.raw_distance || {N: ''}).N}</td>
                  <td>{(eventObj.sensor_entity_update.M.smoothed_raw_distance || {N: ''}).N}</td>
                  <td>{(eventObj.smoothed_fill_level || {N: ''}).N}</td>
                  <td>{(eventObj.sensor_entity_update.M.temperature || {N: ''}).N}</td>
                  <td>{(eventObj.sensor_entity_update.M.battery || {N: ''}).N}</td>
                  <td>{eventObj.sensor_entity_update.M.spreading_factor.S}</td>
                  <td>{(eventObj.sensor_entity_update.M.errors || {L: ['']}).L.map(error => {
                    return error.S
                  }).join(', ')}</td>
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  resourceLoaded: function() {
    const events = state.api.assets[ownProps.assetId].events || {}
    return events.isLoaded || false
  }(),
  canMakeResourceRequest: function() {
    const events = state.api.assets[ownProps.assetId].events || {}
    return state.oidc.user && !state.oidc.user.expired && !(events.isLoading || false) && !(events.isError || false)
  }(),
  events: function() {
    const events = state.api.assets[ownProps.assetId].events || {}
    return events.Events
  }()
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  listAssetEvents: (params = {}) => {dispatch(listAssetEvents(ownProps.assetId))}
})

export default connect(
  mapStateToProps,
  mapDispatchToProps 
)(AssetEvents)